import { SOURCES } from './sources.js';

export const EVENTS = [
  // ── Traditions ──────────────────────────────────────────────────────────────
  {
    id: 'rumble-at-the-ridge',
    name: 'Rumble at the Ridge',
    description:
      'Annual student-vs-teachers basketball game organized by Student Council. Proceeds support the CRMS Alumni Scholarship. One of the most popular events of the year.',
    category: 'tradition',
    whoCanAttend: 'all-students',
    whenLabel: 'TBA — typically late winter',
    date: null,
    source: SOURCES.crmsHome,
    parentAction: null,
  },
  {
    id: 'golden-eagle-award',
    name: 'Golden Eagle Award',
    description:
      'Student recognition program. Nominations are submitted by students, staff, or families via a Google Form on the CRMS homepage. Awarded throughout the year to students who demonstrate the school\'s core values.',
    category: 'tradition',
    whoCanAttend: 'all-students',
    whenLabel: 'Ongoing throughout the year',
    date: null,
    source: SOURCES.crmsHome,
    parentAction: null,
  },
  {
    id: 'picture-day',
    name: 'Picture Day',
    description:
      'Official school portrait day. Date not yet published for 2026-27. Watch for ParentSquare messages from CRMS in August.',
    category: 'tradition',
    whoCanAttend: 'all-students',
    whenLabel: 'TBA — check ParentSquare in August',
    date: null,
    source: SOURCES.crmsHome,
    parentAction: null,
  },
  {
    id: 'field-day',
    name: 'Field Day',
    description:
      'Annual outdoor activity day with games and events for all students. Date TBA — typically scheduled in late spring.',
    category: 'tradition',
    whoCanAttend: 'all-students',
    whenLabel: 'TBA — late spring',
    date: null,
    source: SOURCES.crmsHome,
    parentAction: null,
  },

  // ── Library Club ────────────────────────────────────────────────────────────
  {
    id: 'read-a-thon',
    name: 'Read-A-Thon',
    description:
      'Library Club\'s signature fundraiser with sustained reading time, Quidditch, craft stations, and a feast — for student readers (not siblings or parents). Online pledge fundraising. Proceeds fund Trivia Night, Film Festival, Maker Days, Book Clubs, and library supplies.',
    category: 'fundraiser',
    whoCanAttend: 'all-students',
    whenLabel: 'TBA — posted on CRMS Library site each August',
    date: null,
    source: SOURCES.crmsLibrary,
    parentAction: null,
  },
  {
    id: 'trivia-night',
    name: 'Trivia Night',
    description:
      'Library Club event where teams compete in a campus trivia competition. Funded by the Read-A-Thon. Specific date TBA — watch the CRMS Library site.',
    category: 'fundraiser',
    whoCanAttend: 'all-students',
    whenLabel: 'TBA — watch CRMS Library site',
    date: null,
    source: SOURCES.crmsLibrary,
    parentAction: null,
  },
  {
    id: 'film-festival',
    name: 'Film Festival',
    description:
      'Library Club event showcasing student-made films. Funded by the Read-A-Thon. Specific date TBA — watch the CRMS Library site.',
    category: 'fundraiser',
    whoCanAttend: 'all-students',
    whenLabel: 'TBA — watch CRMS Library site',
    date: null,
    source: SOURCES.crmsLibrary,
    parentAction: null,
  },
  {
    id: 'maker-days',
    name: 'Maker Days',
    description:
      'Library Club hands-on making and creativity events throughout the year. Funded by the Read-A-Thon. Multiple sessions — dates TBA on the CRMS Library site.',
    category: 'fundraiser',
    whoCanAttend: 'all-students',
    whenLabel: 'TBA — throughout the year',
    date: null,
    source: SOURCES.crmsLibrary,
    parentAction: null,
  },

  // ── Dances ──────────────────────────────────────────────────────────────────
  {
    id: 'school-dances',
    name: 'School Dances',
    description:
      'CRMS hosts its own middle school dances during the year. Dates and themes are announced on the campus calendar. Note: middle school students cannot attend high school dances.',
    category: 'dance',
    whoCanAttend: 'all-students',
    whenLabel: 'TBA — check campus calendar in August',
    date: null,
    source: SOURCES.crmsHome,
    parentAction: null,
  },

  // ── Pep Rallies ─────────────────────────────────────────────────────────────
  {
    id: 'pep-rallies',
    name: 'Pep Rallies',
    description:
      'School spirit events held in the gym, typically aligned with athletic seasons. Cheerleaders perform, and students show Eagle pride. Dates announced on campus calendar.',
    category: 'pep-rally',
    whoCanAttend: 'all-students',
    whenLabel: 'TBA — multiple times per year, check campus calendar',
    date: null,
    source: SOURCES.crmsAthletics,
    parentAction: null,
  },

  // ── Spirit Weeks ─────────────────────────────────────────────────────────────
  {
    id: 'spirit-weeks',
    name: 'Spirit Weeks',
    description:
      'Themed dress-up weeks throughout the year — school colors, pajama day, decade day, and more. Dates and themes announced on campus calendar and ParentSquare.',
    category: 'spirit-week',
    whoCanAttend: 'all-students',
    whenLabel: 'TBA — multiple times per year',
    date: null,
    source: SOURCES.crmsHome,
    parentAction: null,
  },

  // ── Ceremonies ──────────────────────────────────────────────────────────────
  {
    id: 'eighth-grade-promotion',
    name: '8th Grade Promotion Ceremony',
    description:
      'Celebration marking 8th graders\' completion of middle school. Families are invited. Exact date TBA — typically late May.',
    category: 'ceremony',
    whoCanAttend: 'family',
    whenLabel: 'TBA — late May 2027',
    date: null,
    source: SOURCES.crmsHome,
    parentAction: null,
  },

  // ── Curriculum Events ────────────────────────────────────────────────────────
  {
    id: 'human-sexuality-7-8',
    name: 'Human Sexuality Curriculum (7th & 8th Grade)',
    description:
      'LISD\'s Human Sexuality Curriculum delivered to 7th and 8th graders. Covers anatomy, puberty, reproduction, pregnancy, relationships, communication, and boundaries (TEKS-aligned). This is OPT-IN under Texas HB 1525 — parents must submit a form before the published deadline or the student will not participate. Preview the curriculum online before deciding.',
    category: 'curriculum',
    whoCanAttend: '7th-8th-only',
    whenLabel: 'Mid-May — expect similar timing to 2025 (May 12–14)',
    date: null,
    source: SOURCES.humanSexuality,
    parentAction:
      'Submit opt-in form at crms.leanderisd.org/parent_resources/human-sexuality-7th-8th before the deadline (watch for announcement in spring 2027)',
  },
  {
    id: 'puberty-lessons-6th',
    name: 'Puberty Lessons — 6th Grade (via PE / Pre-Athletics)',
    description:
      'Sixth graders receive age-appropriate puberty lessons through their PE or Pre-Athletics class — this is separate from the Human Sexuality Curriculum that 7th and 8th graders can opt into. No separate opt-in is required. Parents receive an email from PE/Pre-Athletics/Dance coaches before the lessons begin (in 2025 this was the week of April 21).',
    category: 'curriculum',
    whoCanAttend: '6th-only',
    whenLabel: 'Spring — typically April, delivered via PE/Pre-Athletics',
    date: null,
    source: SOURCES.humanSexuality,
    parentAction: null,
  },
];

export default EVENTS;
